import React from 'react'
import Layout from '../../components/layout/Layout'
import CategorizeBannersTable from '../../elements/tables/banners/CategorizeBannersTable'

export default function Banner() {
  return (
    <div>
      <Layout>
        {/* <BannerTable /> */}
        {/* <CategorizeBannerTable /> */}
        <CategorizeBannersTable />
      </Layout>
    </div>
  )
}
